import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	content_language,
	translate,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const permissions = useRef(null);

	const entities_list = useRef(null);
	const external_list = useRef(null);
	const get_acompanhamento = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [name, setName] = useState('');
	const [profile, setProfile] = useState('');
	const [userId, setUserId] = useState(null);

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	const [notify_responsable_create, set_notify_responsable_create] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)

	const [document_state_aprove, set_document_state_aprove] = useState(false)
	const [clienteSearch, setCompanySearch] = useState("");

	const normalize = (str) =>
		str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() ?? '';

	const filteredCompanies = external_list.current?.filter(el =>
		normalize(el.label).includes(normalize(clienteSearch))
	);

	const { pathname } = useLocation()

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
		}

		return result

	}

	const fetch_external_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/special/${getTokenInfo().companycode}/Empresa`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.info.entity_type) === parseInt('2'))
		}
		return result

	}

	const fetch_intranet_quality_epi = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt'),
					colorPrimary: el.info.color.primary,
					colorSecondary: el.info.color.secondary,
					priority: el.info.priority
				}

				result.push(aux)
			}
		}

		return result
	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase();
			const nameB = b.name.toUpperCase();
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			return 0;
		});

	}


	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			let name = e;

			name = name.replace('_regist', '_list')

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {

					for await (let subitem of node.submenu) {

						if (subitem.path === name) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
							}
							else {
								aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
							}

							set_dados(permissions.current = aux)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			for await (let node of sidebar) {
				if (node.path === name) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					set_dados(permissions.current = aux)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	useEffect(() => {

		(async () => {
			clean_data();

			set_lang(localStorage.getItem('lang'))

			set_dados(entities_list.current = [])

			await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

			if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

				for await (let el of getTokenInfo().entity_profile) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
				}

			}

			const get_attr = async () => {

				let res_4 = await fetch_entities_list()
				if (res_4.length > 0) {
					res_4 = order_array(res_4)

					let res_aux_4 = []
					for await (let el of res_4) {
						res_aux_4.push({
							id: el.id,
							label: el.name,
							email: el.email
						})
					}
					set_dados(entities_list.current = res_aux_4)
				}
				let res_5 = await fetch_intranet_quality_epi('acompanhamento_type')
				if (res_5.length > 0) {
					res_5 = order_array(res_5)
					set_dados(get_acompanhamento.current = res_5)
				}
				let res_6 = await fetch_external_list()
				if (res_6.length > 0) {
					let res_aux_6 = []
					for await (let el of res_6) {
						res_aux_6.push({
							id: el.id,
							label: el.info.name,
							email: el.info.email
						})
					}
					set_dados(external_list.current = res_aux_6)
				}

				setLoading(false);

				return true

			}

			const fetch_id_info = async (id_serch) => {

				try {

					let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)

					// res.data pode conter mais do que um registo — é preciso
					// encontrar o que corresponde ao id pedido, nunca assumir
					// que é sempre o primeiro do array.
					let found = Array.isArray(res.data)
						? res.data.find(el => String(el.id) === String(id_serch))
						: null;

					set_dados(dados.current = found ?? res.data[0]);

					set_is_edit(true)

					get_attr()

				} catch (error) {
					console.error("Erro:", error);
				}
			}
			try {
				let test = props.location.state.operation;

				if (test === 'edit') {
					await fetch_id_info(props.location.state.item.id)
				}
				else {
					await get_attr()
				}

			} catch {
				clean_data()

				await get_attr()

				return
			}

		})()

	}, [props]);

	useEffect(() => {
		const storedData = localStorage.getItem('token');
		if (storedData) {
			const data = JSON.parse(storedData);
			if (data.user_info) {
				if (data.user_info.user_info) {

				} else {

					setProfile(data.user_info.profile);
					setName(data.user_info.name);
					setUserId(data.user_info.id);

				}

			}
		}
	}, []);

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"
						}

						if (notify_responsable_create) {
							if (dados?.current?.info?.responsable?.create?.id !== undefined && dados.current.info.responsable.create.id !== '') {
								let aux_id = dados.current.info.responsable.create.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									// no-op
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										// no-op
									}
									else {
										dados.current.info.settings.document_state = "1"
									}
								}
							}
						}

						await reqPUT(api_crud_route, dados.current)
							.then(async () => {
								if (notify_responsable_aproval) {
									if (dados?.current?.info?.responsable?.aproval?.id !== undefined && dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'quality',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)
										}

									}
								}
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"
						}

						if (notify_responsable_create) {
							if (dados?.current?.info?.responsable?.create?.id !== undefined && dados.current.info.responsable.create.id !== '') {
								let aux_id = dados.current.info.responsable.create.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									// no-op
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
									}
									else {
										dados.current.info.settings.document_state = "1"
									}
								}
							}
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								// props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		setRefresh(r => r + 1)
	}

	const change_cliente = (e) => {
		const { name, value } = e.target;

		if (!value) {
			dados.current.info.contacts[name] = { name: '', id: '' };
			setRefresh(r => r + 1);
			return;
		}

		const label = e.target.options[e.target.selectedIndex]?.text ?? '';

		if (!dados.current.info.contacts) {
			dados.current.info.contacts = {};
		}

		dados.current.info.contacts[name] = {
			name: label,
			id: value,
		};

		set_dados({
			...dados.current,
			info: {
				...dados.current.info,
				contacts: {
					...dados.current.info.contacts,
				},
			},
		});
	};

	// ==================== TABELA: ESQUEMA DE TRATAMENTO SUPERFICIAL ====================

	const add_pintura_row = () => {
		if (dados.current.info.tabela_pintura === undefined) {
			dados.current.info.tabela_pintura = [];
		}

		dados.current.info.tabela_pintura.push({
			id: uniqid(),
			tipo_aplicacao: '',
			prep_superficie: '',
			primario: { tipo: '', esp_seca: '' },
			acabamento: { tipo: '', esp_seca: '' },
			ral: ''
		});

		setRefresh(r => r + 1);
	};

	const handle_change_pintura_row = (e, id) => {
		const { name, value, dataset } = e.target;
		const { group } = dataset; // 'primario' | 'acabamento' (opcional)

		if (dados.current.info.tabela_pintura === undefined) {
			dados.current.info.tabela_pintura = [];
		}

		dados.current.info.tabela_pintura.forEach((el) => {
			if (String(el.id) === String(id)) {
				if (group) {
					if (el[group] === undefined) el[group] = {};
					el[group][name] = value;
				} else {
					el[name] = value;
				}
			}
		});

		setRefresh(r => r + 1);
	};

	const change_pintura_tipo_aplicacao = (e, id) => {
		const { value } = e.target;
		const label = e.target.options[e.target.selectedIndex].text;

		dados.current.info.tabela_pintura.forEach((el) => {
			if (String(el.id) === String(id)) {
				el.tipo_aplicacao = value ? { id: value, label } : '';
			}
		});

		setRefresh(r => r + 1);
	};

	const remove_pintura_row = (id) => {
		dados.current.info.tabela_pintura = dados.current.info.tabela_pintura.filter(
			(el) => String(el.id) !== String(id)
		);

		setRefresh(r => r + 1);
	};

	const change_document_responsable = (e) => {
		const { name, value } = e.target;

		if (!dados.current.info.responsable) dados.current.info.responsable = {};
		if (name === 'create') set_notify_responsable_create(true);
		else if (name === 'aproval') set_notify_responsable_aproval(true);

		const aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value));
		const aux = { id: value, name: '', notification: '', execution: '' };
		if (aux_entity.length > 0) aux.name = aux_entity[0].label;

		set_dados(dados.current.info.responsable[name] = aux);
		setRefresh(r => r + 1);
	};

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																		<div className="row mb-4">
																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].cliente}</label>

																				<input
																					type="text"
																					placeholder={language[lang].search ?? 'Search...'}
																					value={clienteSearch}
																					onChange={(e) => setCompanySearch(e.target.value)}
																					className="form-control rounded-0 mb-1"
																				/>

																				<select
																					name="cliente"
																					className="form-select form-control mb-2 rounded-0"
																					onChange={(e) => {
																						setCompanySearch('');
																						change_cliente(e);
																					}}
																					value={dados?.current?.info?.contacts?.cliente?.id ?? ""}
																					required
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{filteredCompanies?.map((el_el, k_el) => (
																						<option key={k_el} value={el_el.id}>
																							{el_el.label}
																						</option>
																					))}
																				</select>
																			</div>

																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].createdBy}</label>
																				<select
																					name="create"
																					className="form-select form-control mb-2 rounded-0"
																					onChange={change_document_responsable}
																					required
																					value={dados?.current?.info?.responsable?.create?.id !== undefined && dados?.current?.info?.responsable?.create?.id !== null ? dados.current.info.responsable.create?.id : ''}
																				>
																					{userId && (
																						<option value={userId}>{name}</option>
																					)}

																					{
																						entities_list.current !== undefined && entities_list.current !== null ?
																							entities_list.current.map((el_el, k_el) => (
																								<option key={k_el} value={el_el.id}>
																									{el_el.label}
																								</option>
																							))
																							:
																							null
																					}
																				</select>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-6 col-md-6">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_obra}</label>
																				<input
																					type="text"
																					name="obra"
																					defaultValue={dados.current.info.obra}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																				/>
																			</div>

																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].data_admissao}</label>
																				<input
																					type="datetime-local"
																					name="data_admissao"
																					data-type="execution"
																					defaultValue={dados.current.info.data_admissao !== undefined && dados.current.info.data_admissao !== null ? dados.current.info.data_admissao.split('Z')[0] : ''}
																					placeholder={language[lang].data_admissao_placeholder}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																					required
																				/>
																			</div>

																			<div className="col-12 col-md-4 d-none">
																				<label className="fs-6 fw-bold mb-2">{language[lang].data_demissao}</label>
																				<input
																					type="datetime-local"
																					name="data_demissao"
																					data-type="execution"
																					defaultValue={dados.current.info.data_demissao !== undefined && dados.current.info.data_demissao !== null ? dados.current.info.data_demissao.split('Z')[0] : ''}
																					placeholder={language[lang].data_demissao_placeholder}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																				/>
																			</div>
																		</div>
																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>

											<div className="card-body p-4">
												<div className="row mb-4">
													<div className="col-12">
														<div className="d-flex justify-content-between align-items-center mb-3">
															<label className="fs-6 fw-bold mb-0">{language[lang].tabela_pintura_title}</label>
															{permissions.current !== null && permissions.current.create ?
																<button
																	type="button"
																	className="btn btn-sm btn-light border rounded-pill px-3 shadow-sm d-inline-flex align-items-center"
																	onClick={add_pintura_row}
																>
																	<i className="bi bi-plus-lg me-2"></i>
																	<span>{language[lang].add_new_row}</span>
																</button>
																: null
															}
														</div>

														<div className="table-responsive border rounded-2 overflow-hidden">
															<table className="table table-hover align-middle mb-0 tabela-pintura">
																<thead>
																	<tr className="table-light">
																		<th rowSpan={2} className="text-start align-middle" style={{ minWidth: 200 }}>
																			{language[lang].tipo_aplicacao}
																		</th>
																		<th rowSpan={2} className="text-start align-middle" style={{ minWidth: 160 }}>
																			{language[lang].prep_superficie}
																		</th>
																		<th colSpan={2} className="text-center border-start">
																			{language[lang].primario}
																		</th>
																		<th colSpan={2} className="text-center border-start">
																			{language[lang].acabamento}
																		</th>
																		<th rowSpan={2} className="text-start align-middle border-start" style={{ minWidth: 100 }}>
																			{language[lang].ral}
																		</th>
																		<th rowSpan={2} className="align-middle" style={{ width: 48 }}></th>
																	</tr>
																	<tr className="table-light">
																		<th className="text-start fw-normal text-muted border-start" style={{ minWidth: 130 }}>
																			{language[lang].tipo}
																		</th>
																		<th className="text-start fw-normal text-muted" style={{ minWidth: 110 }}>
																			{language[lang].esp_seca}
																		</th>
																		<th className="text-start fw-normal text-muted border-start" style={{ minWidth: 130 }}>
																			{language[lang].tipo}
																		</th>
																		<th className="text-start fw-normal text-muted" style={{ minWidth: 110 }}>
																			{language[lang].esp_seca}
																		</th>
																	</tr>
																</thead>
																<tbody>
																	{dados.current.info?.tabela_pintura !== undefined && Array.isArray(dados.current.info.tabela_pintura) && dados.current.info.tabela_pintura.length > 0 ?
																		dados.current.info.tabela_pintura.map((el_row) => (
																			<tr key={el_row.id}>
																				<td>
																					<select
																						name="tipo_aplicacao"
																						data-id={el_row.id}
																						className="form-select form-control form-control-sm rounded-1"
																						value={el_row.tipo_aplicacao?.id ?? ''}
																						onChange={(e) => change_pintura_tipo_aplicacao(e, el_row.id)}
																					>
																						<option value="">{language[lang].field_choose}</option>
																						{get_acompanhamento?.current?.map((el, k) => <option key={k} value={el.id}>{el.name}</option>)}
																					</select>
																				</td>
																				<td>
																					<input
																						type="text"
																						name="prep_superficie"
																						data-id={el_row.id}
																						defaultValue={el_row.prep_superficie}
																						onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																						className="form-control form-control-sm rounded-1"
																					/>
																				</td>
																				<td>
																					<input
																						type="text"
																						name="tipo"
																						data-id={el_row.id}
																						data-group="primario"
																						defaultValue={el_row.primario?.tipo}
																						onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																						className="form-control form-control-sm rounded-1"
																					/>
																				</td>
																				<td>
																					<div className="input-group input-group-sm">
																						<input
																							type="number"
																							name="esp_seca"
																							data-id={el_row.id}
																							data-group="primario"
																							min={0}
																							defaultValue={el_row.primario?.esp_seca}
																							onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																							className="form-control rounded-1"
																						/>
																						<span className="input-group-text rounded-1 text-muted">µm</span>
																					</div>
																				</td>
																				<td>
																					<input
																						type="text"
																						name="tipo"
																						data-id={el_row.id}
																						data-group="acabamento"
																						defaultValue={el_row.acabamento?.tipo}
																						onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																						className="form-control form-control-sm rounded-1"
																					/>
																				</td>
																				<td>
																					<div className="input-group input-group-sm">
																						<input
																							type="number"
																							name="esp_seca"
																							data-id={el_row.id}
																							data-group="acabamento"
																							min={0}
																							defaultValue={el_row.acabamento?.esp_seca}
																							onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																							className="form-control rounded-1"
																						/>
																						<span className="input-group-text rounded-1 text-muted">µm</span>
																					</div>
																				</td>
																				<td>
																					<input
																						type="text"
																						name="ral"
																						data-id={el_row.id}
																						defaultValue={el_row.ral}
																						onChange={(e) => handle_change_pintura_row(e, el_row.id)}
																						className="form-control form-control-sm rounded-1"
																					/>
																				</td>
																				<td className="text-center">
																					{permissions.current?.create &&
																						<button
																							type="button"
																							className="btn btn-sm btn-outline-danger border-0"
																							onClick={() => remove_pintura_row(el_row.id)}
																						>
																							<i className="bi bi-trash"></i>
																						</button>
																					}
																				</td>
																			</tr>
																		))
																		: (
																			<tr>
																				<td colSpan={7} className="text-center text-muted py-4">
																					{language[lang].no_rows ?? 'Sem linhas adicionadas'}
																				</td>
																			</tr>
																		)
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}